import { Slider } from 'antd';
import styled, { useTheme } from 'styled-components';
import { useState } from 'react';

type IconSliderPropsType = {
    max: number;
    min: number;
    value: number | undefined;
    index: number;
    handleChange: (index: number, value: number) => void;
    disabled: boolean;
    reversed: boolean;
    marks: Record<string, string>;
};

const SliderWrapper = styled.div`
    position: relative;
    padding: 0px 30px;

    .anticon {
        position: absolute;
        top: -15px;
        bottom: 0px;
        width: 16px;
        height: 16px;
        font-size: 40px;
        line-height: 1;
        right: -20px;
    }

    .initial .ant-slider-track {
        background-color: rgba(0, 0, 0, 0.25);
    }

    .changed .ant-slider-track {
        background-color: '#91d5ff';
    }
    .initial .ant-slider-handle {
        border-color: rgba(0, 0, 0, 0.25);
    }

    .changed .ant-slider-handle {
        border-color: '#91d5ff';
    }
`;

const IconSlider = ({ max, min, value, index, handleChange, disabled, reversed, marks }: IconSliderPropsType) => {
    const [className, setClassName] = useState('initial');

    const handleSliderChange = (sliderValue: number) => {
        if (className === 'initial') setClassName('changed');
        handleChange(index, sliderValue);
    };

    const theme: any = useTheme();

    return (
        <SliderWrapper>
            <Slider
                max={max}
                min={min}
                marks={marks}
                onChange={(newValue: number) => handleSliderChange(newValue)}
                value={value}
                className={className}
                disabled={disabled}
                trackStyle={{ backgroundColor: theme?.background.border }}
                handleStyle={{
                    borderColor: theme?.background.pink,
                    backgroundColor: theme?.background.pink,
                    width: '20px',
                    height: '20px',
                    top: 0,
                }}
            />
        </SliderWrapper>
    );
};

export default IconSlider;
